// removed by extract-text-webpack-plugin
module.exports = {"textArea":"CwTextArea-textArea","invalid":"CwTextArea-invalid"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtextarea/CwTextArea.scss
// module id = 1039
// module chunks = 10